import { Cancel, Check } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import React from 'react';

const ConfirmDelete = ({
  open,
  handleSuccess,
  toggleDialog,
  title = 'Are you sure you want to delete this user?'
}) => {
  return (
    <Dialog
      open={open}
      onClose={toggleDialog}
      sx={{
        '& .MuiDialog-paper': {
          minWidth: 450
        }
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogActions>
        <Button
          onClick={handleSuccess}
          variant='contained'
          color='success'
          startIcon={<Check />}
        >
          Yes
        </Button>
        <Button
          onClick={toggleDialog}
          variant='contained'
          color='error'
          startIcon={<Cancel />}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDelete;
